import React from "react";

export default function TagDefault({ text, color, my = "3" }) {
  return (
    <>
    {text && (
      <div
        className={`group flex flex-row text-white text-xs font-semibold text-nowrap max-w-min`}
      >
        <span className={`pl-4 bg-${color} py-1 line-clamp-2`}>{text}</span>
        <span className={`bg-${color} py-1 w-4 button-angle-right `}></span>
      </div>
    )}
    </>
  );
}
